const defaultState: any = []
const riskScoreReducer = (state = defaultState, action: any) => {
    switch (action.type) {
        case 'GET_CLIENTS_LOADING':
            return { ...state, loading: true };
        case 'GET_CLIENTS_SUCCESS':
            return { ...state, loading: false, data: JSON.parse(action.payload) };
        case 'GET_CLIENTS_ERROR':
            return { ...state, loading: false, error: true };
        default:
            return state;
    }
}

export default riskScoreReducer;
